import React from 'react';

const UnauthorizedTitle = () => {
    return <><i className="fa fa-3x mb-3 fa-ban text-light" aria-hidden="true"></i><h1 className="text-light text-center">Unauthorized</h1></>
}


export default  UnauthorizedTitle;